import { Container } from "ct-design";
import { getAmenities } from "src/utils/amenities";

const Amenities = ({ data }: { data: string[] }) => {
  return (
    <Container className="mx-4 my-6">
      {data?.length > 0 ? (
        <Container className="flex">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(300px, auto))",
            }}
          >
            {data.map((item, index) => {
              if (item.toLowerCase() !== "gps")
                return (
                  <div key={index} className="grid-item">
                    <Container key={index} className="py-3 flex-1">
                      <Container className="flex flex-middle">
                        {getAmenities(item)}
                        <p className="fw-500 fs-16 ml-2 lh-25">{item}</p>
                      </Container>
                    </Container>
                  </div>
                );
            })}
          </div>
        </Container>
      ) : (
        <div className="fs-14">
          We’re sorry, this information is currently unavailable.
        </div>
      )}
    </Container>
  );
};

export default Amenities;
